import React, { ChangeEvent, Dispatch } from 'react'
import { Col, Input, InputNumber, Row, Typography } from 'antd'
import useGlobal, { GlobalState, GlobalActions } from '../../../../Store'
import { s } from './style'
import { formatCents } from '../../../../Utilities'
import { OptionalExtrasProposalFragment } from './OptionalExtras.generated-types'
import { CURRENCY } from '../../../../Constants'

interface OptionalExtrasProps {
  proposal: OptionalExtrasProposalFragment
  editing: boolean
  setProposal: Dispatch<any>
}

const MAX_CHARACTERS = 20

const { Text } = Typography

export const OptionalExtras: React.FC<OptionalExtrasProps> = ({
  proposal,
  proposal: { ID: proposalID, extraCostItems, currency },
  editing,
  setProposal,
}) => {
  const [globalState, globalActions] = useGlobal<GlobalState, GlobalActions>()

  const handleUpdateDescription = (event: ChangeEvent<HTMLInputElement>, index: number): void => {
    const newProposal = { ...proposal }
    newProposal.extraCostItems[index].description = event.target.value
    setProposal(newProposal)
  }

  const handleUpdateCostPerUnit = (newCostPerUnit: number, index: number): void => {
    const withPence = newCostPerUnit * 100

    const newProposal = { ...proposal }
    newProposal.extraCostItems[index].costPerUnit = withPence
    setProposal(newProposal)
  }

  return (
    <Col>
      {extraCostItems.map(({ ID, description, costPerUnit }, index) => {
        const handleChange = (quantity: number): void => {
          globalActions.setBookedItems({
            ID: proposalID,
            bookedItems: {
              [ID]: { ID, quantity: quantity || 0 },
            },
          })
        }

        return (
          <Row key={ID} style={s.costItemRow}>
            {editing ? (
              <Input
                defaultValue={description}
                onChange={(event) => handleUpdateDescription(event, index)}
              />
            ) : (
              <Text style={s.costItem}>
                {description?.length > MAX_CHARACTERS
                  ? `${description.substr(0, MAX_CHARACTERS)}...`
                  : description}
              </Text>
            )}

            <div style={s.costAndAmount}>
              {editing ? (
                <InputNumber
                  defaultValue={costPerUnit / 100}
                  prefix={CURRENCY[currency]}
                  onChange={(newCostPerUnit) => handleUpdateCostPerUnit(newCostPerUnit, index)}
                />
              ) : (
                <Text style={{ ...s.costItem, float: 'right' }}>
                  {`${formatCents(currency, costPerUnit)} x `}
                </Text>
              )}
              <InputNumber
                size='middle'
                min={0}
                precision={0}
                value={globalState[proposalID]?.bookedItems[ID]?.quantity}
                onChange={handleChange}
              />
            </div>
          </Row>
        )
      })}
    </Col>
  )
}
